import { Spinner } from "../ui";
import "../Planner/planner.css";

/** Centered loading animation for modal bodies (uses `assets/loading.svg`). */
export function ModalLoadingState({
  accessibilityLabel = "Loading",
  message
}: {
  accessibilityLabel?: string;
  /** Optional visible caption shown under the spinner (e.g. "Finding upcoming events…"). */
  message?: string;
}) {
  return (
    <div className="fgp-modal-loading">
      <Spinner accessibilityLabel={message ?? accessibilityLabel} />
      {message && (
        <p className="fgp-modal-loading__msg" aria-hidden>
          {message}
        </p>
      )}
    </div>
  );
}
